import LocalizedStrings from 'localized-strings';
import { LOCALIZATIONS } from 'root/lib/constants';
import { getLocalization } from 'a/selectors/languageSelectors';
import QuestsNames from 'a/hub/data/QuestsNames.json';
import GameDisplayNames from 'a/hub/data/GameDisplayNames';
import BackpackPowersText from 'a/hub/data/BackpackPowersText';
import BackpackNotebookText from 'a/hub/data/BackpackNotebookText.json';

import eReaderTranslations from './eReader';
import growthTranslations from './growth';

// Reading
export const en = Object.freeze({
  yes: 'yes',
  no: 'no',
  go: 'Go!',
  interested: 'interested',
  inventive: 'inventive',
  truthful: 'truthful',
  hints: 'Hints',
  note: 'Note',
  clue: 'Clue',
  show: 'Show',
  done: 'Done',
  play: 'Play',
  resume: 'Resume',
  pause: 'Pause',
  finish: 'Finish',
  next: 'Next',
  goBack: 'Go back',
  tryAgain: 'Try again',
  continue: 'Continue',
  logOut: 'Log out',
  keepGoingYoureGrowing: 'Keep going, you’re growing!',
  goodImprovement: 'Good improvement!',
  anyPracticeIsWorthwhile: 'Any practice is worthwhile!',
  youVeGot: 'You’ve got',
  success: 'Success',
  completed: 'Completed',
  almost: 'Almost',
  goodEffort: 'Good Effort',
  thatWasChallenging: 'That was challenging',
  letsKeepPracticing: 'Let’s keep practicing!',
  letsTakeABreak: 'Let’s take a break.',
  wellComeBackToThisLater: 'We’ll come back to this later.',
  firstRead: '1st read',
  secondRead: '2nd read',
  goblin: 'goblin',
  targetWord: 'Target word',
  hearAudio: 'Hear audio',
  playAudio: 'Play audio',
  confirmChoice: 'Confirm choice',
  gameBackground: 'Game background',
  arrow: 'arrow',
  category: 'category',
  right: 'right',
  left: 'left',
  challenge: 'Challenge',
  ereader: eReaderTranslations.en,
  ...QuestsNames.reading,
  ...GameDisplayNames.reading,
  openBackpack: 'Open Backpack',
  backpackSections: 'Backpack sections',
  augmentationSectionsTitle: 'Augmentation sections',
  usageProgress: 'Weekly usage progress',
  usageProgressDetail: 'Progress: {0} of {1} minutes.',
  checkUsage: 'Click me for progress!',
  close: 'Close',
  usageProgressMessages: {
    start: 'Hi!\nLet\'s get started!',
    progress: 'Welcome back!\nKeep going to reach your goal!',
    finish: 'Great work!\nYou hit your weekly goal!',
    currentUsage: 'Hi!\nYou practiced for\n{0} min this week.',
  },
  backpack: 'Backpack',
  closeBackpack: 'Close backpack, back to map',
  closeChallengeModal: 'Close Challenge Modal, open Backpack',
  nextItems: 'Next set of options',
  prevItems: 'Last set of options',
  nextCategories: 'Next Categories',
  prevCategories: 'Previous Categories',
  nextPage: 'Next Page',
  prevPage: 'Previous Page',
  gameCategory: 'Game Category',
  game: 'Game',
  // backpack - growth
  ...growthTranslations.en,
  // backpack - powers
  powers: 'Powers',
  mySkills: 'My Skills',
  ...BackpackPowersText.reading,
  // backpack - items (season 1)
  items: 'Items',
  myStuff: 'My Stuff',
  // backpack - notes (season 2)
  notes: 'Notes',
  notebook: 'Notebook',
  ...BackpackNotebookText.reading,
  // backpack - practice
  practice: 'Practice',
  findMe: 'Find Me',
  // Hangry Goblins
  angryRedGoblin: 'angry red goblin',
  hangryGoblins: 'Hangry Goblins',
  // Picky Goblins
  hearAnswer: 'Hear this answer.',
  pickAnswer: 'Pick this answer.',
  toastLabel: 'A toast for the goblin with the letter {0}',
  itemGrabbed: 'Item is grabbed. Press Enter to confirm selection.',
  draggableItem: 'A draggable item. Press Enter to activate the Actions menu.',
  // Progress screen
  playTutorial: 'Play tutorial.',
  masteredlevel: 'Mastered level {0}.',
  playUnlocked: 'Play latest unlocked level, level {0}.',
  playLatest: 'Play latest level.',
  tryLatest: 'Try latest level again.',
  tryLevelAgain: 'Try level {0} again.',
  exitGame: 'Exit game',
  curiosoProgress: 'Your curioso, progress is {0}%.',
  // Curioso Picker
  Furry: 'Furry',
  Scaly: 'Scaly',
  Feathery: 'Feathery',
  Playing: 'Playing',
  Lost: 'Lost',
  Exploring: 'Exploring',
  Brave: 'Brave',
  Friendly: 'Friendly',
  Silly: 'Silly',
  isIt: {
    skin: 'Is it',
    nature: 'Is it',
    mood: 'Is it',
  },
  tap: 'Tap',
  onThe: 'on the',
  bag: 'bag',
  letsGo: 'Let’s go',
  AllGames: 'All Games',
  StartQuiz: 'Start Quiz',
  Done: 'Done',
  agree: 'Agree',
  disagree: 'Disagree',
  fixIt: 'Fix It',
  bookertonBee: 'Bookerton Bee',
  // CutItOut
  cutItOut: {
    hearAudio: 'Hear audio',
    confirmChoice: 'Confirm choice',
    speakerIcon: 'Speaker icon',
    close: 'Close',
    camera: 'Camera',
  },
  messageInABottle: {
    sentencePlaceholder: 'Drag the words here to make a sentence.',
  },
  // All Aboard
  allABoard: {
    allAboard: 'All Aboard',
    startOverOn: 'Start over on this question',
    checkAnswer: 'Check your answer',
    hearAgain: 'Hear the word again',
    sound: 'sound',
    syllable: 'syllable',
    go: 'Go',
    youMadeIt: 'You made it!',
    tryAgain: 'Try Again',
    removeAnswer: (sound, answer) => `Remove a ${sound}  from your answer, ${answer}`,
    addAnswer: (sound, answer) => `Add a ${sound} to your answer, ${answer}`,
    currentSound: sound => `The current answer is 1 ${sound} long`,
    currentSounds: (count, sounds) => `Current answer is ${count} ${sounds}s long`,
  },
  // Sort It Out
  hard: letter => `Hard ${letter}`,
  soft: letter => `Soft ${letter}`,
  yConsonant: 'y-consonant',
  yAsConsonant: 'y as consonant',
  yVowel: 'y-vowel',
  yAsVowel: 'y as vowel',
  leftButtonArrow: letter => `Tap left arrow to submit target to ${letter} Word`,
  rightButtonArrow: letter => `Tap right arrow to submit target to ${letter} Word`,
  pumpkinSeeds: 'Pumpkin Seeds',
  pumpkinSeedsDescription: "Mrs. Lombard's pumpkins sure have a lot of seeds.",
  hotChocolate: 'Hot Chocolate',
  hotChocolateDescription: "Sam loves Lyle's hot chocolate. It's his favorite on a cold day!",
  stopwatch: 'Stopwatch',
  stopwatchDescription: 'Benita uses this stopwatch to see how fast she is.',
  lemons: 'Lemons',
  lemonsDescription: "Lemons like this helped with Garry's sore throat.",
  giantBeans: 'Giant Beans',
  giantBeansDescription: 'These giant beans helped Lyle with his giant soup!',
  songBook: 'Song Book',
  songBookDescription: 'With enough practice, Sam can be a fantastic musician.',
  liLisSubmarine: "Li-Li's Submarine",
  liLisSubmarineDescription: "Li-li's toy submarine has been in a lot of adventures.",
  flower: 'Flower',
  flowerDescription: 'Even a great artist like Roberta can be touched by a simple flower.',
  wildlifeBook: 'Wildlife Book',
  wildlifeBookDescription: 'This book talks about all kinds of animals living in Bookerton.',
  yarn: 'Yarn',
  yarnDescription: 'Mrs. Lombard may not like sewing, but she sure is good at it!',
  muttsPoem: "Mutt's Poem",
  muttsPoemDescription: 'Who knew Mutt could write such beautiful poetry?',
  weatherNotebook: 'Weather Notebook',
  weatherNotebookDescription: "Garry's notebook records the town's weather for hundreds of years!",
  poster: 'Poster',
  posterDescription: "It's exciting that Lyle finally gets to star in the town's play.",
  honeyJar: 'Honey Jar',
  honeyJarDescription: 'Li-Li lured the bear away with this honey and her quick thinking.',
  blarneyStone: 'Blarney Stone',
  blarneyStoneDescription: "The Blarney Stone sure helped with Sam's shyness.",
  tickets: 'Tickets',
  ticketsDescription: "The whole town is going to see Roberta's play!",
  emilsDrawing: "Emil's Drawing",
  emilsDrawingDescription: "Claude isn't just a teddy bear; he's Emil's best friend!",
  button: 'Button',
  buttonDescription: 'When Claude lost his eye, Emil replaced it with this button.',
  charmBracelet: 'Charm Bracelet',
  charmBraceletDescription: 'Emil collected charms for his bracelet for years!',
  pinCushion: 'Pin Cushion',
  pinCushionDescription: 'Good thing Mrs. Lombard could help Sam with his costume!',
  scarab: 'Scarab',
  scarabDescription: 'In Egypt, this beetle is a symbol for birth and renewal!',
  bookertonStew: 'Bookerton Stew',
  bookertonStewDescription: 'Mutt wanted to honor the whole town with his stew!',
  askAlyx: 'Ask Alyx to say the instructions again',
  shadeShifting: {
    wild: 'wild',
    tame: 'tame',
    warm: 'warm',
    hot: 'hot',
    small: 'small',
    large: 'large',
    pamphlet: 'pamphlet',
    inedible: 'inedible',
    appetizing: 'appetizing',
    damaged: 'damaged',
    pristine: 'pristine',
    smeared: 'smeared',
    legible: 'legible',
    color: 'color',
    racoons: 'racoons',
    oven: 'oven',
    treats: 'treats',
    wire: 'wire',
    writing: 'writing',
    photo: 'photo',
    bulb: 'bulb',
    familiarWriting: 'familiar writing',
    blackAndWhite: 'black & white',
    tinyPamphlet: 'Tiny pamphlet',
    coolLight: 'cool light',
    warmLight: 'warm light',
    tenderSteaks: 'tender steaks',
    realisticWoodpecker: 'realistic woodpecker',
    dryClothes: 'dry clothes',
    mildScent: 'mild scent',
    inedibleTreats: 'Inedible Treats',
    wildRacoons: 'Wild Racoons',
    warmOven: 'Warm Oven',
    damagedWire: 'Damaged Wire',
    smearedWriting: 'Smeared writing',
    blackAndWhitePhoto: 'Black and white photo',
    coolLightBulb: 'Cool Light Bulb',
    toughSteaks: 'Tough Steaks',
    abstractWoodpecker: 'Abstract Woodpecker',
    soakedClothes: 'Soaked Clothes',
    faintScent: 'Faint Scent',
    alienWriting: 'Alien Writing',
  },
  hearTheWord: 'Hear the word again',
  // numbers
  one: 'one',
  two: 'two',
  three: 'three',
  // Skill Scan
  skillScan: {
    itsTime: 'It\'s time to show off your skills!',
    notEnoughData: 'Not enough data!',
    takeYourTime: 'Take your time and try your best next time.',
    goodEffort: 'Good Effort!',
    niceWork: 'Nice Work!',
    excellentWork: 'Excellent Work!',
    yourCuriosoEarned: 'Your Curioso earned an energy boost!',
    yourCuriosoEarnedNum: numStars => `Your Curioso earned ${numStars} out of three energy boosts!`,
    playSkillScan: 'Play Curioso Skill Scan',
    curiosoSkillScan: 'Curioso Skill Scan',
    startPlaying: 'Start playing Boost',
    teacherReset: 'Your teacher has reset Skill Scan. Take your time, and try your best!',
    letsGo: 'Let\'s go',
  },
  // WordSlide
  wordSlide: {
    confirm: 'Confirm',
    column: 'Column',
    targetWord: 'Target Word',
    wordSlide: 'Word Slide',
  },
  // EstaOAquella
  questionSubmitButton: 'Click to hear the word',
  // Wordbots
  wordbots: {
    selectedWord: word => `Selected word, ${word}`,
    selectedWordHearAudio: word => `Selected word, ${word}, press Enter to hear audio`,
    wordbotSelectTheWord: word => `wordbot ${word},press Enter to hear audio,
    then press Enter again to select the word`,
    targetWord: 'target word',
  },
  wordCity: {
    done: 'Done',
    continueRound: 'Continue',
    wreckingBall: 'wrecking ball tile; click to remove letters',
    emptyTile: 'empty letter tile drop zone,',
    // indexed by topperId; order mirrors each color block of SvgMap's svgTopperRewardComponents
    topperNames: ['flag', 'bird', 'cake', 'garage', 'gorilla', 'helicopter', 'mountain'],
    topperPosition: '{0} topper, reward {1} of {2}',
    selectTopper: 'Select',
    leftArrow: 'Left arrow, Click left to view more toppers',
    rightArrow: 'Right arrow, Click right to view more toppers',
  },
  realWordReading: {
    chooseTheWord: 'Choose the word that you hear.',
  },
  gemNye: {
    progressScreenBackground: 'Gem and Nye',
  },
  planTorres: {
    done: 'Listo',
    doneClick: 'Done, click to continue',
    wreckingBall: 'wrecking ball tile; click to remove letters',
    emptyTile: 'empty letter tile drop zone,',
    topper: 'Topper, end of level reward,',
    leftArrow: 'Left arrow, Click left to view more toppers',
    rightArrow: 'Right arrow, Click right to view more toppers',
  },
  mindTheGap: {
    chooseAMissingWord: 'Choose a missing word.',
    chooseTheWordThatCompletesTheSentence: 'Choose the word that completes the sentence.',
  },
  modals: {
    allQuestsComplete: 'Congratulations! You unlocked the Challenge Quests',
    challengeText: 'Choose a game to help your curioso grow!',
    session: {
      areYouStillThere: 'Are you still there?',
      wow: "Wow! It's been a while!",
      logOff: 'Want to log off and take a break?',
      keepPlaying: 'Keep playing',
    },
    logOut: {
      back: 'Go back',
      areYouSure: 'Are you sure you want to log out?',
    },
    multipleSessions: {
      header: 'Extra Tabs',
      prompt: 'Boost is open in more than one place.\nPlease click the blue button to continue playing here.',
      continue: 'Continue',
    },
  },
  doorPuzzle: {
    definingTrait: "'s defining trait:",
    herTrait: 'what is her defining trait?',
    hisTrait: 'what is his defining trait?',
    hint: 'This word also means',
    findTheClue: 'Find the clue hiding in your diary!',
    modal: {
      title: 'You’ve been working really hard. Would you like to keep trying?',
      tryAgain: 'Yes, keep trying!',
      help: 'No, help me!',
    },
    honest: {
      word: 'honest',
      description: 'someone who respects the truth',
    },
    creative: {
      word: 'creative',
      description: 'someone who uses her imagination',
    },
    curious: {
      word: 'curious',
      description: 'someone with an itch for exploration',
    },
    titles: {
      correct: 'Good job!',
      incorrect: "That was close, let's try again!",
      scanning: 'Scanning...',
      submit: 'Press Done to submit',
      default: 'Connect the letters to make a word',
    },
  },
  quest215: {
    noteClueFile: 'IngameQ15NoteClue',
    noteClueName: 'ItemsQ15NoteClue',
  },
  quest217: {
    largeInscription: 'ItemsQ17LargeInscription',
    largeCrest: 'ItemsQ17LargeBookertoncrest',
  },
  quest224: {
    glyphdoorTop: 'Q224FullscreenGlyphdoorTop',
  },
  inkBlott: {
    means: 'means',
    completed: 'You have completed this cavern!',
    youNeed: 'You need ',
    scrolls: ' scrolls to visit the next cavern!',
  },
  laRanaBrincacharcos: {
    boxNumbers: ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven'],
    hearWord: 'Click to hear: "{0}"',
    selectElkoninBox: 'Box {0}: click to submit a syllable',
    deselectElkoninBox: 'Box {0}: click again to remove a syllable',
    playElkoninBox: 'Box {0}: click to hear a syllable',
    playBeats: 'Click to hear the total number of beats',
    submitButtonLabel: 'Click to submit the total number of beats',
    okay: 'OK',
    okLabel: 'OK, click to continue',
  },
  showOff: {
    submitAnswer: 'Submit answer',
    readCard: 'Read the card aloud',
    done: 'Done',
    revealImage: 'Reveal the card image',
  },
});

// es is the same as en for Reading. Future specific changes can be added here using desconstruction
export const es = Object.freeze({
  ...en,
  realWordReading: {
    chooseTheWord: 'Toca la palabra que escuches.',
  },
  mindTheGap: {
    chooseAMissingWord: 'Elige una palabra que falta.',
    chooseTheWordThatCompletesTheSentence: 'Elige la palabra que complete la oración.',
  },
});

// Lectura
export const spaEsDefault = Object.freeze({
  yes: 'sí',
  no: 'no',
  go: '¡Vamos!',
  hints: 'Consejo',
  note: 'Nota',
  clue: 'Pista',
  show: 'Muestra',
  interested: 'interés',
  inventive: 'inventiva',
  truthful: 'sinceridad',
  logOut: 'Cerrar sesión',
  play: 'Iniciar',
  finish: 'Terminar',
  next: 'Siguiente',
  done: 'Listo',
  agree: 'Aceptar',
  disagree: 'Discrepar',
  resume: 'Continuar',
  pause: 'Pausa',
  fixIt: '¡A Corregir!',
  bookertonBee: 'La Voz de Bookerton',
  goBack: 'Volver a los niveles',
  tryAgain: 'Inténtalo otra vez',
  continue: 'Continuar',
  keepGoingYoureGrowing: '¡Adelante! ¡Estás mejorando!',
  goodImprovement: '¡Buena mejora!',
  anyPracticeIsWorthwhile: '¡Cualquier práctica vale la pena!',
  youVeGot: 'Obtuviste',
  success: '¡Muy bien!',
  completed: 'Completado',
  almost: '¡Casi!',
  goodEffort: 'Buen intento',
  thatWasChallenging: 'Eso estuvo un poco difícil.',
  letsKeepPracticing: '¡Sigamos practicando!',
  letsTakeABreak: 'Vamos a descansar. Volveremos',
  wellComeBackToThisLater: 'a este juego más tarde.',
  firstRead: '1.ª lectura',
  secondRead: '2.ª lectura',
  goblin: 'tragaletras',
  targetWord: 'Palabra clave',
  hearAudio: 'Escuchar audio',
  playAudio: 'Reproducir audio',
  confirmChoice: 'Confirmar selección',
  gameBackground: 'Fondo del juego',
  arrow: 'flecha',
  category: 'categoría',
  right: 'derecha',
  left: 'izquierda',
  challenge: 'Desafío',
  ereader: eReaderTranslations.spaEsDefault,
  ...QuestsNames.lectura,
  ...GameDisplayNames.lectura,
  backpack: 'Mochila',
  backpackSections: 'Secciones de mochila',
  augmentationSectionsTitle: 'Secciones de aumento',
  usageProgress: 'Progreso de uso semanal',
  usageProgressDetail: 'Progreso: {0} de {1} minutos.',
  checkUsage: '¡Haz clic en mí para ver tu progreso!',
  close: 'Cerrar',
  usageProgressMessages: {
    start: '¡Hola!\n¡Vamos a empezar!',
    progress: '¡Bienvenido de nuevo! ¡Sigue adelante para alcanzar tu meta!',
    finish: '¡Excelente trabajo!\n¡Alcanzaste tu meta semanal!',
    currentUsage: '¡Hola!\nEsta semana practicaste {0} min.',
  },
  openBackpack: 'Abrir mochila',
  closeBackpack: 'Cerrar mochila, volver al mapa',
  closeChallengeModal: 'Cerrar el modal de desafío, abrir la mochila',
  prevItems: 'Conjunto anterior de opciones',
  nextItems: 'Siguiente conjunto de opciones',
  nextCategories: 'Siguiente categoría',
  prevCategories: 'Categoría anterior',
  nextPage: 'Siguiente página',
  prevPage: 'Página anterior',
  gameCategory: 'Categoría de juego',
  game: 'Juego',
  // backpack - growth
  ...growthTranslations.spaEsDefault,
  // backpack - powers
  powers: 'Poderes',
  mySkills: 'Mis Destrezas',
  ...BackpackPowersText.lectura,
  // backpack - items (season 1)
  items: 'Objeto',
  myStuff: 'Mis cosas',
  // backpack - notes (season 1)
  notes: 'Notas',
  notebook: 'Cuaderno',
  ...BackpackNotebookText.lectura,
  // backpack - practice
  practice: 'Práctica',
  findMe: 'Encuéntrame',
  // Hangry Goblins
  angryRedGoblin: 'tragaletras rojo de enojo',
  hangryGoblins: 'Tragaletras comelotodo',
  // Picky Goblins
  hearAnswer: 'Escucha esta respuesta.',
  pickAnswer: 'Escoge esta respuesta.',
  toastLabel: 'un pedazo de pan con la letra {0}',
  draggableItem: 'Pulsa enter para activar el menú de acciones.',
  itemGrabbed: 'Respuesta seleccionada. Pulsa enter para confirmar.',
  // Progress screen
  playTutorial: 'Juega el tutorial.',
  masteredlevel: 'nivel dominado {0}.',
  playUnlocked: 'juega el siguiente nivel desbloqueado, nivel {0}.',
  playLatest: 'jugar el siguiente nivel disponible.',
  tryLatest: 'Intentar otra vez.',
  tryLevelAgain: 'Prueba el nivel {0} nuevamente.',
  exitGame: 'Salir del juego.',
  curiosoProgress: 'El progreso de tu curioso es {0}%.',
  // Curioso Picker
  Furry: 'Peludo',
  Scaly: 'Escamoso',
  Feathery: 'Plumoso',
  Playing: 'Jugando',
  Lost: 'Perdido',
  Exploring: 'Explorando',
  Brave: 'Valiente',
  Friendly: 'Amistoso',
  Silly: 'Cómico',
  isIt: {
    skin: '¿Es Algo?',
    nature: '¿Está?',
    mood: '¿Será?',
  },
  tap: 'Toca',
  onThe: 'la',
  bag: 'mochila',
  letsGo: '¡Empecemos',
  StartQuiz: 'Listo',
  Done: 'Hecho',
  AllGames: 'Todos los juegos',
  messageInABottle: {
    sentencePlaceholder: 'Arrastra las palabras aquí para formar una oración.',
  },
  // All Board
  allABoard: {
    allAboard: '¡Todos a Bordo!',
    startOverOn: 'Vuelve a intentar con esta pregunta',
    checkAnswer: 'Revisa tu respuesta',
    hearAgain: 'Escucha la palabra otra vez',
    sound: 'sonido',
    syllable: 'sonido',
    go: 'Listo',
    youMadeIt: '¡Lo lograste!',
    tryAgain: 'Inténtalo otra vez',
    removeAnswer: (sound, answer) => `Quita el ${sound} a tu respuesta, ${answer}`,
    addAnswer: (sound, answer) => `Agrega el ${sound} a tu respuesta, ${answer}`,
    currentSound: sound => `Esta respuesta tiene 1 ${sound}`,
    currentSounds: (count, sounds) => `Esta respuesta tiene ${count} ${sounds}s`,
  },
  // CutItOut
  cutItOut: {
    hearAudio: 'Escuchar audio',
    confirmChoice: 'Confirmar selección',
    speakerIcon: 'Icono de altavoz',
    close: 'Cerrar',
    camera: 'Cámara',
  },
  // Sort It Out
  hard: letter => `${letter} fuerte`,
  soft: letter => `${letter} suave`,
  yConsonant: 'y-consonante',
  yAsConsonant: 'y como consonante',
  yVowel: 'y-vocal',
  yAsVowel: 'y como vocal',
  leftButtonArrow: letter => `Presiona la flecha izquierda para enviar la palabra con ${letter}`,
  rightButtonArrow: letter => `Presiona la flecha derecha para enviar la palabra con ${letter}`,
  pumpkinSeeds: 'Semillas de calabaza',
  pumpkinSeedsDescription: 'Las calabazas de la Sra. Lombard sí tienen muchas semillas.',
  hotChocolate: 'Chocolate caliente',
  hotChocolateDescription: 'A Sam le encanta el chocolate caliente de Lyle. Es su favorito en un día frío.',
  stopwatch: 'Cronómetro',
  stopwatchDescription: 'Benita usa este cronómetro para ver qué tan rápida es.',
  lemons: 'Limones',
  lemonsDescription: 'Los limones como estos ayudaron a Garry con su garganta irritada.',
  giantBeans: 'Frijoles gigantes',
  giantBeansDescription: 'Estos frijoles gigantes ayudaron a Lyle con su sopa gigante.',
  songBook: 'Cancionero',
  songBookDescription: 'Si practica lo suficiente, Sam puede ser un músico fantástico.',
  liLisSubmarine: 'El submarino de Li-Li',
  liLisSubmarineDescription: 'El submarino de juguete de Li-Li ha estado en muchas aventuras.',
  flower: 'Flor',
  flowerDescription: 'Hasta una gran artista como Roberta puede emocionarse con una simple flor.',
  wildlifeBook: 'Libro de la vida silvestre',
  wildlifeBookDescription: 'En este libro se describen todos los tipos de animales que viven en Bookerton.',
  yarn: 'Hilo',
  yarnDescription: 'A la Sra. Lombard quizás no le guste coser, pero es muy buena cuando lo hace.',
  muttsPoem: 'El poema de Mutt',
  muttsPoemDescription: '¿Quién hubiera dicho que Mutt podía escribir poesía tan bella?',
  weatherNotebook: 'Cuaderno del tiempo',
  weatherNotebookDescription:
    '¡En el cuaderno de Garry está anotado el estado del tiempo del pueblo durante cientos de años!',
  poster: 'Cartel',
  posterDescription: 'Qué emocionante que Lyle por fin pueda ser la estrella en la obra de teatro del pueblo.',
  honeyJar: 'Frasco de miel',
  honeyJarDescription: 'El oso se fue porque Li-Li lo distrajo con esta miel y porque pensó con rapidez.',
  blarneyStone: 'Piedra de Blarney',
  blarneyStoneDescription: 'La Piedra de Blarney sí que ayudó a Sam con su timidez.',
  tickets: 'Entradas',
  ticketsDescription: 'Todo el pueblo va a ir a ver la obra de Roberta.',
  emilsDrawing: 'El dibujo de Emil',
  emilsDrawingDescription: 'Claude no es solo un osito; es el mejor amigo de Emil.',
  button: 'Botón',
  buttonDescription: 'Cuando Claude perdió un ojo, Emil lo reemplazó con este botón.',
  charmBracelet: 'Pulsera de ornamentos',
  charmBraceletDescription: '¡Emil coleccionó ornamentos para su pulsera durante años!',
  pinCushion: 'Alfiletero',
  pinCushionDescription: 'Qué bueno que la Sra. Lombard pudo ayudar a Sam con su vestuario.',
  scarab: 'Escarabajo',
  scarabDescription: 'En Egipto, este escarabajo es un símbolo de nacimiento y renovación.',
  bookertonStew: 'Guiso de Bookerton',
  bookertonStewDescription: 'Mutt quiso hacer un homenaje a todo el pueblo con su guiso.',
  askAlyx: 'Pídele a Alyx que diga las instrucciones de nuevo',
  readySoccerPlayer: 'Futbolista listo',
  jumpingSoccerPlayer: 'Futbolista que salta',
  runningSoccerPlayer: 'Futbolista que corre',
  wavingSoccerPlayer: 'Futbolista que hace señas con la mano',
  soccerPlayerCenter: 'centro',
  soccerPlayerLeft: 'izquierda',
  soccerPlayerRight: 'derecha',
  // EstaOAquella
  questionSubmitButton: 'Haga clic para escuchar la palabra',
  shadeShifting: {
    wild: 'salvajes',
    tame: 'manso',
    warm: 'cálido',
    hot: 'caliente',
    small: 'pequeño',
    large: 'grande',
    pamphlet: 'panfleto',
    inedible: 'incomibles',
    appetizing: 'apetitosas',
    damaged: 'dañado',
    pristine: 'prístino',
    smeared: 'manchado',
    legible: 'legible',
    color: 'color',
    racoons: 'mapaches',
    oven: 'horno',
    treats: 'golosinas',
    wire: 'cable',
    writing: 'escrito',
    photo: 'foto',
    bulb: 'bombilla',
    familiarWriting: 'conocido escrito',
    blackAndWhite: 'blanco y negro',
    tinyPamphlet: 'Mini panfleto',
    coolLight: 'luz fría',
    warmLight: 'luz calurosa',
    tenderSteaks: 'bistecs blandos',
    realisticWoodpecker: 'pájaro carpintero realista',
    dryClothes: 'ropa seca',
    mildScent: 'olor suave',
    inedibleTreats: 'Golosinas incomibles',
    wildRacoons: 'Mapaches salvajes',
    warmOven: 'Horno cálido',
    damagedWire: 'Cable dañado',
    smearedWriting: 'Escrito manchado',
    blackAndWhitePhoto: 'Foto en blanco y negro',
    coolLightBulb: 'Bombilla de luz fría',
    toughSteaks: 'Bistecs duros',
    abstractWoodpecker: 'Pájaro carpintero abstracto',
    soakedClothes: 'Ropa empapada',
    faintScent: 'Olor tenue',
    alienWriting: 'Extraño escrito',
  },
  hearTheWord: 'Escucha la palabra de nuevo',
  // numbers
  one: 'uno',
  two: 'dos',
  three: 'tres',
  // Skill Scan
  skillScan: {
    itsTime: '¡Es momento para demostrar tus habilidades!',
    notEnoughData: '¡No hay suficientes datos!',
    takeYourTime: 'Toma tu tiempo y haz lo mejor que puedas la próxima vez.',
    goodEffort: '¡Buen esfuerzo!',
    niceWork: '¡Bien hecho!',
    excellentWork: '¡Excelente trabajo!',
    yourCuriosoEarned: '¡Tu Curioso se ganó un impulso de energía!',
    yourCuriosoEarnedNum: numStars => `¡Tu Curioso se ganó ${numStars} de tres impulsos de energía!`,
    playSkillScan: 'Juega Escaneo de destreza de Curioso',
    startPlaying: 'Comienza a jugar Boost',
    curiosoSkillScan: 'Escaneo de destreza de Curioso',
    teacherReset: 'Tu profesor ha restablecido el Escaneo de destreza. ¡Tómate tu tiempo y da lo mejor de ti!',
    letsGo: 'Vamos',
  },
  // WordSlide
  wordSlide: {
    confirm: 'Confirmar',
    column: 'Columna',
    targetWord: 'Palabra Objetivo',
    wordSlide: 'Resbalaletras',
  },
  // Wordbots
  wordbots: {
    selectedWord: word => `Palabra seleccionada, ${word}`,
    selectedWordHearAudio: word => `Palabra seleccionada, ${word}, presiona Entrar para escuchar el audio`,
    wordbotSelectTheWord: word => `robot de palabras ${word}, presiona Entrar para escuchar el audio,
    luego presiona Entrar otra vez para seleccionar la palabra`,
    targetWord: 'Palabra objetivo',
  },
  wordCity: {
    done: 'Listo',
    continueRound: 'Continuar',
    wreckingBall: 'bola de demolición',
    emptyTile: 'zona de descenso,',
    topperNames: ['bandera', 'pájaro', 'pastel', 'garaje', 'gorila', 'helicóptero', 'montaña'],
    topperPosition: 'premio de {0}, {1} de {2}',
    selectTopper: 'Elegir',
    leftArrow: 'flecha izquierda, presiona para ver más premios',
    rightArrow: 'flecha derecha, presiona para ver más premios',
  },
  realWordReading: {
    chooseTheWord: 'Haz clic en la palabra.',
  },
  gemNye: {
    progressScreenBackground: 'Alfa y Beto',
  },
  planTorres: {
    done: 'Listo',
    doneClick: 'Done, click to continue',
    wreckingBall: 'wrecking ball tile; click to remove letters',
    emptyTile: 'empty letter tile drop zone,',
    topper: 'Topper, end of level reward,',
    leftArrow: 'Left arrow, Click left to view more toppers',
    rightArrow: 'Right arrow, Click right to view more toppers',
  },
  mindTheGap: {
    chooseAMissingWord: 'Elige una palabra que falta.',
    chooseTheWordThatCompletesTheSentence: 'Elige la palabra que complete la oración.',
  },
  modals: {
    allQuestsComplete: '¡Felicitaciones! Has desbloqueado el modo desafío.',
    challengeText: 'Escoge un juego para ayudar a crecer a tu Curioso.',
    session: {
      areYouStillThere: '¿Estás ahí?',
      wow: '¡Ha pasado un rato!',
      logOff: '¿Quieres cerrar la sesión y descansar?',
      keepPlaying: 'Seguir jugando',
    },
    logOut: {
      back: 'Volver',
      areYouSure: '¿Estás seguro que quieres cerrar la sesión?',
    },
    multipleSessions: {
      header: 'Pestañas Adicionales',
      prompt: 'Boost está abierto en más de un lugar.\nPor favor, haz clic en el botón azul para continuar jugando aquí.',
      continue: 'Continuar',
    },
  },
  doorPuzzle: {
    herTrait: '¿qué característica la define?',
    hisTrait: '¿qué característica lo define?',
    hint: 'Esta palabra también significa',
    findTheClue: 'Encuentra la pista escondida en tu diario.',
    definingTrait: 'característica define:',
    modal: {
      title: 'Has estado trabajando muy duro. ¿Te gustaría seguir intentándolo?',
      tryAgain: '¡Sí, sigue intentándolo!',
      help: '¡No, ayúdame!',
    },
    honest: {
      word: 'honest',
      description: 'alguien que respeta la verdad',
    },
    creative: {
      word: 'creativi',
      description: 'alguien que usa su imaginación',
    },
    curious: {
      word: 'curiosi',
      description: 'alguien que sueña con la exploración',
    },
    titles: {
      correct: '¡Buen trabajo!',
      incorrect: 'Estuvo cerca, ¡intentémoslo de nuevo!',
      scanning: 'Escaneo...',
      submit: 'Presiona Listo para enviar',
      default: 'Combina las letras para formar una palabra',
    },
  },
  quest215: {
    noteClueFile: 'IngameQ15NoteCluees',
    noteClueName: 'ItemsQ15NoteCluees',
  },
  quest217: {
    largeInscription: 'ItemsQ17LargeInscriptiones',
    largeCrest: 'ItemsQ17LargeBookertoncrestes',
  },
  quest224: {
    glyphdoorTop: 'Q224FullscreenGlyphdoorTopes',
  },
  inkBlott: {
    means: 'significa',
    completed: '¡Has completado esta caverna!',
    youNeed: '¡Necesitas ',
    scrolls: ' pergaminos para visitar la siguiente caverna!',
  },
  laRanaBrincacharcos: {
    boxNumbers: ['cero', 'uno', 'dos', 'tres', 'cuatro', 'cinco', 'seis', 'siete'],
    hearWord: 'Haz clic para escuchar: "{0}"',
    selectElkoninBox: 'Caja {0}: haz clic para confirmar la sílaba',
    deselectElkoninBox: 'Caja {0}: haz clic para quitar la sílaba',
    playElkoninBox: 'Caja {0}: haz clic para escuchar la sílaba',
    playBeats: 'Haz clic para escuchar el número total de pulsos',
    submitButtonLabel: 'Haz clic para confirmar el número total de pulsos',
    okay: 'Listo',
    okLabel: 'OK, haz clic para continuar',
  },
  showOff: {
    submitAnswer: 'Enviar respuesta',
    readCard: 'Leer la tarjeta en voz alta',
    done: 'Listo',
    revealImage: 'Revelar la imagen de la tarjeta',
  },
});

export const localizedStrings = new LocalizedStrings({
  [LOCALIZATIONS.EN]: en,
  [LOCALIZATIONS.ES]: es,
  [LOCALIZATIONS.SPA_ES_DEFAULT]: spaEsDefault,
});

/**
 * Updates the default interface language with the key language.
 * @param {string} language
 */
export const setDefaultInterfaceLanguage = (language) => {
  const option = '_interfaceLanguage';
  localizedStrings[option] = language;
};

export const setLanguageLocalized = (language) => {
  localizedStrings.setLanguage(language);
  setDefaultInterfaceLanguage(language);
};

export const setLocalizedThunk = () => (dispatch, getState) => {
  const language = getLocalization(getState());
  localizedStrings.setLanguage(language);
  setDefaultInterfaceLanguage(language);
};
